export enum NotificationAttachmentType {
    CONVERSATION = 'CONVERSATION',
    PAYMENT = 'PAYMENT',
    PRODUCT_REQUEST = 'PRODUCT_REQUEST',
    FORM = 'FORM',
}
